import { createRoute, useParams } from '@tanstack/react-router';
import { PoDetailPage } from '@/features/stock/PoDetailPage';
import { Route as shellRoute } from '../_shell';

function PoRoute() {
  const { poId } = useParams({ from: '/stock/inbound/$poId' });
  return <PoDetailPage poId={poId} />;
}

/** One purchase order: lines, allocation, batches, advance and reverse. */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/stock/inbound/$poId',
  component: PoRoute,
});
